// this contains all base table styles including headers, rows, cells etc
import { css } from 'lit-element';

/*
        TODO: this needs another pass or two to clean up un-used things
*/

export class TableStyles {
    static get styles() {
        return [
            css`
                /* color vars */
                :host {
                    --table-stripe-odd-color: #f9f9f9;
                    --table-stripe-even-color: var(--app-surface-color);
                    --table-stripe-draw: #f9f9f9;
                    --table-stripe-win: #e5ffe7;
                    --table-stripe-loss: #ffe9e9;
                }

                table {
                    width: var(--tmn-table-width, auto);
                    /*
                    min-width is here to make the table look "ok" when it is very small
                    need to be careful that it isn't in cases like standings. while  e variable can be tweaked
                    it would be better if we can find something fairly general, might be able to remove this now
                     that we are not centering the table?;
                     */
                    min-width: var(--tmn-table-min-width, 250px);
                    display: var(--tmn-table-display, table);
                    table-layout: var(--tmn-table-layout, auto);
                    border-spacing: 0;
                    font-size: var(--table-font-size, 0.85rem);
                    background: var(--app-surface-color);
                }

                .caption {
                    background: var(--app-surface-color);
                    color: var(--app-primary-color);
                    text-align: start;
                    white-space: nowrap;
                    padding: 6px 0;
                    font-size: 13px;
                    font-family: Lato, sans-serif;
                }

                .caption .results-text {
                    margin: 0 6px;
                }

                .caption .data-message {
                    font-style: italic;
                }

                .caption .placeholder {
                    min-width: 100px;
                }

                thead {
                    border-top: 1px solid #dee3ea;
                }
                a.table-link:hover {
                    text-decoration: underline;
                }

                a {
                    user-select: none;
                    text-decoration: none;
                    /* flex:1; */
                    color: var(--routed-link-color);
                }

                .configurableTable a.table-link {
                    color: unset;
                    text-decoration: underline;
                }

                th,
                td {
                    color: #394046;
                    border-top-color: #b9ccdf;
                    border-top: 1px solid #ddd;
                    padding-top: var(--tmn-table-td-padding, 4px);
                    padding-bottom: var(--tmn-table-td-padding, 4px);
                    padding-right: 6px;
                    padding-left: 6px;
                }

                .entity-column {
                    min-width: 150px;
                }

                .minimize-width {
                    width: 1px;
                    padding-left: 6px;
                    padding-right: 6px;
                    white-space: nowrap;
                }

                .allow-wrap {
                    width: auto;
                    white-space: normal;
                    display: block;
                    display: -webkit-box;
                    max-height: 39px;
                    margin: 0 auto;
                    line-height: 20px;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .numeric {
                    text-align: right;
                }

                .sorted {
                    background-color: var(--app-primary-light-color);
                    font-weight: 700;
                }
                tbody th,
                td {
                    vertical-align: middle;
                    height: var(--table-cell-height, auto);
                }

                thead th,
                .column-header th {
                    padding-bottom: 5px !important;
                    padding-top: 5px !important;
                    font-size: 12px;
                    height: 30px;
                    color: #333;
                    vertical-align: middle;
                }

                .column-tooltips {
                    font-size: 12px;
                    color: #333;
                    font-weight: bold;
                }

                tbody > tr:nth-child(odd) {
                    background-color: var(--table-stripe-odd-color);
                }
                tbody > tr:nth-child(even) {
                    background-color: var(--table-stripe-even-color);
                }

                th > div {
                    height: 100%;
                    width: 100%;
                    user-select: none;
                    padding: 2px;
                    display: inline-flex;
                    text-align: center;
                    align-items: center;
                }

                thead[chart-edit-cols-mode='true'] tr > th,
                tbody .activated {
                    color: #428bca;
                    cursor: pointer;
                    font-weight: bold;
                    text-decoration: underline;
                }

                tbody th,
                td {
                    white-space: nowrap;
                }

                /* consider getting styles like this from rowformatter */
                tbody > tr.active {
                    background: #e5ffe7;
                }

                tbody > tr.win {
                    background: var(--table-stripe-win);
                }

                tbody > tr.loss {
                    background: var(--table-stripe-loss);
                }

                tbody > tr.draw {
                    background: var(--table-stripe-draw);
                }

                /* end  tmn_table_styles */

                td.action {
                    white-space: nowrap !important;
                    width: 0.01%;
                }

                thead th,
                .column-header th {
                    position: relative;
                    text-align: left;
                }

                /* make tbody th more like td, this is so we can use th for freeze-able columns */
                tbody th {
                    font-weight: unset;
                    text-align: unset;
                    background: inherit;
                    /* z-index: 1; */
                }

                .column-header th {
                    /* seems to be the only way to override the "tbody th" unsets above ^ */
                    font-weight: bold;
                }

                :host([sortable]) th {
                    cursor: pointer;
                }

                table thead th,
                .column-header th {
                    border-top: 1px solid #b9ccdf;
                    border-bottom: 1px solid #b9ccdf;
                }

                tbody tr:first-child td {
                    border-top: none;
                }

                @media print {
                    .configurableTable a.table-link {
                        text-decoration: none;
                    }
                }
            `,
        ];
    }
}
